<template>
  <div class="content">
    <contact-form :datas="dataall"></contact-form>
    <firma></firma>
    <sklad :datas="dataall"></sklad>
    <b-modal id="modal-close" centered>
      <h4>
        {{ $t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?') }}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.kontragent.Savedokument()">{{ $t('Да') }}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{ $t('Нет') }}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{ $t('Отмена') }}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ContactForm, Firma, Sklad } from "@/pages";
export default {
  components: { ContactForm, Firma, Sklad },
  // Create sahifasi uchun
  data() {
    return {
      dataall: {
        phone_number: "+998",
        telegram: "https://t.me/",
        instagram: "https://www.instagram.com/"
      }
    };
  },

  methods: {
    Home() {
      this.$store.state.saved = null;
      this.$bvModal.hide('modal-close');
      this.$router.push({ name: "Контрагент" });
    },
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
